import "../projects.css";

function Neighborhood() {
  return (
    <div className="project-container">
      {/* Hero Banner */}
      <div className="banner">
        <img
          src="/assets/projects/priceline_logo.png"
          alt="Neighborhood Navigator"
          className="banner-image"
        />
      </div>

      {/* Project Header */}
      <div className="project-header">
        <h1 className="project-title">Neighborhood Navigator</h1>
        <p className="project-subtitle">
          A hackathon concept for Priceline that helps Gen Z travelers discover places to stay by browsing neighborhoods first, rather than starting with hotels.
        </p>
        <div className="badge-container">
          <span className="badge">UI/UX Design</span>
          <span className="badge">Prototype</span>
          <span className="badge">Hackathon</span>
          <span className="badge">Figma</span>
        </div>
      </div>

      {/* Overview Section - 3 Columns */}
      <div className="project-overview">
        <div className="overview-3col">
          <div className="overview-col-item">
            <div className="overview-icon">🧭</div>
            <h3 className="overview-title">My Role</h3>
            <p className="overview-text">
              Solo UI/UX designer for the hackathon. I mapped the entire experience, built a clickable prototype, and prepared the presentation for judging.
            </p>
          </div>

          <div className="overview-col-item">
            <div className="overview-icon">⏱️</div>
            <h3 className="overview-title">Timeline</h3>
            <p className="overview-text">
              Weekend hackathon sprint from concept to prototype in under 48 hours. The project won first place.
            </p>
          </div>

          <div className="overview-col-item">
            <div className="overview-icon">✨</div>
            <h3 className="overview-title">Focus</h3>
            <ul className="overview-list">
              <li>Neighborhood-first browsing and discovery</li>
              <li>Gen Z-friendly visuals and microcopy</li>
              <li>Lightweight, tappable prototype for demo</li>
            </ul>
          </div>
        </div>
      </div>

      {/* Design Challenge Section */}
      <div className="case-study-section">
        <h2 className="section-title">Design Challenge</h2>
        <div className="case-study-content">
          <p className="case-study-text">
            We needed a feature that made Priceline feel fresh to Gen Z without heavy build effort. I leaned on neighborhood context, letting users browse by vibe, local highlights, and quick “what’s nearby” peeks to make hotels feel more personal.
          </p>
          <p className="case-study-text">
            Because this was a hackathon, I prioritized a clear interaction model and a demo-ready flow: minimal screens, obvious taps, and storytelling that tied the prototype to measurable engagement goals.
          </p>
          <div className="brand-values">
            <h3 className="brand-values-title">What I Focused On</h3>
            <div className="values-grid">
              <div className="value-item">
                <span className="value-icon">🧩</span>
                <div className="value-content">
                  <strong>Conceptual Model</strong>
                  <span className="value-text">Browse by neighborhood “tiles” that mirror how people pick areas in real life.</span>
                </div>
              </div>
              <div className="value-item">
                <span className="value-icon">🎯</span>
                <div className="value-content">
                  <strong>Prompted Choices</strong>
                  <span className="value-text">Quick prompts (“near food”, “nightlife”, “artsy”) to cut decision fatigue.</span>
                </div>
              </div>
              <div className="value-item">
                <span className="value-icon">🧹</span>
                <div className="value-content">
                  <strong>Minimal Surface</strong>
                  <span className="value-text">Designed minimal screens for the demo with clear CTAs and tappable cards for quick booking.</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Private project notice */}
      <div className="case-study-section">
        <div className="case-study-content">
          <div className="prototype-cta">
            This prototype is private. <a href="mailto:ma.ra@northeastern.edu" className="link-style">Email</a> for a walkthrough or access.
          </div>
        </div>
      </div>
    </div>
  );
}

export default Neighborhood;
